import type { IconType } from "@memorang/ui/src/types";
import { Button, type ButtonProps } from "react-native-paper";

type Props = {
	fullWidth?: boolean;
	icon?: IconType;
} & ButtonProps;
const AuthButton = ({
	onPress,
	children,
	mode = "contained",
	disabled,
	icon,
	loading,
	fullWidth,
}: Props) => (
	<Button
		mode={mode}
		onPress={onPress}
		disabled={disabled}
		style={fullWidth && { width: 500, maxWidth: "100%" }}
		icon={icon}
		loading={loading}
	>
		{children || "Continue"}
	</Button>
);

export default AuthButton;
